import angular from 'angular';
import ngPlaceholder from '../../../directives/ng-placeholder';
import uiBootstrap from 'angular-ui-bootstrap';
import uiRouter from 'angular-ui-router';



const childDurationComponent = angular.module('ttb.widgets.childDuration.component', [
    ngPlaceholder,
    uiBootstrap,
    uiRouter
])
    .component('childDuration', {
        template: require('./child-duration.component.html'), 
        bindings: {
            childDuration: '<',
            formatter: '<',
            activitySubItems: '<'
        },
        controller: ChildDuration
    })
    .name;

function ChildDuration($scope, $element, $timeout,  $state, throttleService) {

    const updateView = () => {
        this.durationView = this.formatter
        ? this.formatter.format(this.childDuration || {})
        : '';
     };

    this.$onInit = () => {
        updateView();
    };

    this.NavigateTo = (params)=>
    {
        $state.go('ItemDetails',{itemId: params.itemId, activityLogId: params.activityLogId});
    }


    this.$onChanges = () => {
        updateView();
    }
}
ChildDuration.$inject = ['$scope', '$element', '$timeout','$state'];

export default childDurationComponent;


// WEBPACK FOOTER //
// ../widgets/duration/childDuration/child-duration.component.js